import Error from "es6-error";

export class IncompletePayloadException extends Error {}
